// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1ZS2F","buttons":"Footer_buttons__CfAE2"};